<template>
<div class="container">
  <div class="map">
    <SearchSearcher ref="searcher" :kommunekode="this.$store.state.kommune.kode" v-on:result="this.onSearchResult" v-on:error="this.onSearchError"/>
    <LayerCarouselButton id="carousel" :map="this.$store.state.map" :layerNames="['Skaermkort','Ortho','Forvaltning']"/>
    <LayerVisibleButton
      id="husnr-layer-selector"
      :map="this.$store.state.map"
      layerName="Husnummer"
      :tooltipTextOn="'Skjul husnumre'"
      :tooltipTextOff="'Vis husnumre'"
    >
      <icon-husnummer-vist slot="on" :width=50 :height=50 />
      <icon-husnummer-skjult slot="off" :width=50 :height=50 />
    </LayerVisibleButton>
    <VejkodeContainer
      :geoDkObjekter="this.$store.state.geoDkObjekter"
      :onVejkodeChange="this.onVejkodeChange"
      :adressering="this.adressering"
      :vejkode="this.initialVejkode"
      :reset="this.reset"
      :removeItem="this.removeGeoDkObjekt"
    />
    <Popup
      :mouseover="hidePopup"
      :x="this.$store.state.popup.x"
      :y="this.$store.state.popup.y"
      :visible="this.$store.state.popup.visible"
      :loading="this.$store.state.popup.loading"
      :vejkode="this.$store.state.popup.vejkode"
      :kommuneKode="this.$store.state.popup.kommuneKode"
      :geoDkId="this.$store.state.popup.geoDkId"
      :vejmidteType="this.$store.state.popup.vejmidteType"
      :vejnavn="this.$store.state.popup.vejnavn"
      :postnummer="this.$store.state.popup.postnummer"
      :postSted="this.$store.state.popup.postSted"
    />
    <div id="attribution">
      <a href="https://septima.dk/">Septima</a>, <a href="https://sdfe.dk/">© SDFE</a>
    </div>
  </div>
</div>
</template>

<script>
import { setupMap } from '@/openLayersMap';
import SearchSearcher from '@/components/search/Search.vue';
import VejkodeContainer from '@/components/map/VejkodeContainer/VejkodeContainer.vue';
import LayerVisibleButton from '@/components/map/LayerVisibleButton.vue';
import IconHusnummerSkjult from '@/components/common/Icon/IconHusnummer/IconHusnummerSkjult.vue';
import IconHusnummerVist from '@/components/common/Icon/IconHusnummer/IconHusnummerVist.vue';
import LayerCarouselButton from '@/components/map/LayerCarouselButton/LayerCarouselButton.vue';
import Popup from '@/components/map/Popup.vue';
import { getAdresseringStringFromVejkodeObjekt } from '@/util';
import DawaApi from '@/api/Dawa';
export default {
  name: 'olmap',
  components: {
    VejkodeContainer,
    LayerVisibleButton,
    IconHusnummerSkjult,
    IconHusnummerVist,
    LayerCarouselButton,
    Popup,
    SearchSearcher,
  },
  data () {
    return {
      map: null,
      layers: [],
      adressering: '',
      initialVejkode: undefined,
      kommunekode: '',
      popupProps: {
        x: 0,
        y: 0,
        visible: false,
        loading: false,
        vejkode: '',
        kommuneKode: 0,
        geoDkId: 0,
        vejmidteType: '',
        vejnavn: '',
        postnummer: '',
      },
    };
  },
  computed: {
    kommune: {
      get: function () {
        return this.$store.state.kommune;
      },
    },
  },
  methods: {
    onSearchResult (result) {
      const coords = result.data.geometry.coordinates;
      if (coords) {
        let xmin = 9999999;
        let ymin = 9999999;
        let xmax = 0;
        let ymax = 0;
        const minimumBBox = 100;
        if (result.data.vejkode) {
          // vej, dawa
          coords.forEach(element => {
            element.forEach(elem => {
              xmin = Math.min(xmin, elem[0]);
              ymin = Math.min(ymin, elem[1]);
              xmax = Math.max(xmax, elem[0]);
              ymax = Math.max(ymax, elem[1]);
            });
          });
        } else if (result.data.geometry.coordinates.length === 2) {
          // adresse, dawa
          xmin = coords[0] - minimumBBox;
          ymin = coords[1] - minimumBBox;
          xmax = coords[0] + minimumBBox;
          ymax = coords[1] + minimumBBox;
        } else {
          // geodkobjekt
          coords.forEach(elem => {
            xmin = Math.min(xmin, elem[0]);
            ymin = Math.min(ymin, elem[1]);
            xmax = Math.max(xmax, elem[0]);
            ymax = Math.max(ymax, elem[1]);
          });
        }
        if (xmax > 0) {
          this.map.getView().fit([xmin, ymin, xmax, ymax]);
        }
      }
      this.$refs.searcher.view.blur();
    },
    onSearchError (errorObj) {
      alert('Error in searcher :(');
    },
    onLayerToggle () {
      this.$store.commit('toggleVisibleLayer');
    },
    onVejkodeChange (vejkode) {
      if (!vejkode) {
        this.adressering = '';
        return;
      }
      let vejkodeMedAdressering = this.$store.state.fetchedVejkoder[vejkode.padStart(4, '0')];
      if (vejkodeMedAdressering) {
        if (vejkodeMedAdressering.ukendt) {
          this.adressering = '';
        } else {
          this.adressering = getAdresseringStringFromVejkodeObjekt(vejkodeMedAdressering);
        }
      } else {
        this.$store.dispatch('getVejkodeAdressering', { kommunekode: this.kommune.kode, vejkode })
          .then(resp => {
            this.adressering = getAdresseringStringFromVejkodeObjekt(resp);
          })
          .catch(() => {
            this.adressering = '';
          });
      }
    },
    reset () {
      this.$store.commit('removeAllGeoDkObjekter');
    },
    removeGeoDkObjekt (geodkObjekt) {
      this.$store.commit('removeGeoDkObjekt', geodkObjekt);
    },
    hidePopup () {
      this.$store.commit('updatePopup', { visible: false });
    },
  },
  created () {
    const { vejkode } = this.$route.query;
    if (vejkode) {
      this.initialVejkode = parseInt(vejkode);
    }
  },
  mounted () {
    if (Object.keys(this.$route.query).length > 0) {
      this.reset();
    }
    const { bbox, geodkobjekter, vejkode } = this.$route.query;
    let queryParams = false;
    if (this.$store.state.map) {
      this.map = this.$store.state.map;
      this.map.setTarget(this.$el.querySelector('.map'));
    } else {
      this.$store.commit('setUseKommuneBBox', true);
      this.map = setupMap(this.$store, this.$el.querySelector('.map'));
    }
    this.$store.commit('setMap', this.map);

    if (bbox) {
      queryParams = true;
      this.map.getView().fit(bbox.split(','));
    }
    if (geodkobjekter) {
      queryParams = true;
      let objekter = geodkobjekter;
      if (!isNaN(objekter)) { // single geodkobjekt from opgave select from front page is number
        objekter = objekter.toString();
      }
      objekter.split(',').forEach(geodkid => {
        this.$store.dispatch('getGeoDkObjektById', { geodkid, makeSureInMap: bbox === undefined });
      });
    }
    if (vejkode) {
      queryParams = true;
      this.initialVejkode = parseInt(vejkode);
    }
    if (queryParams) {
      this.$store.commit('setUseKommuneBBox', false);
    }
    if (!queryParams && this.$store.state.useKommuneBBox) {
      DawaApi.getKommune(this.$store.state.kommune.kode)
        .then(response => {
          this.map.getView().fit(response.bbox);
        });
      this.$store.commit('setUseKommuneBBox', false);
    }
  },
};
</script>

<style lang="scss">
.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.map {
  width: 100%;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  flex: 1;
  min-height: 0;
  z-index: 1;
}

#husnr-layer-selector {
  position: absolute;
  bottom: 10px;
  left: 160px;
}

.ol-zoom {
  top: 80px;
  left: 22px;
  background-color: unset;
}
.ol-zoom:hover {
  background-color: unset;
}

.ol-control button {
  background: #FFFFFF;
  border: 1px solid #EBEDF5;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: $transition-length;
}
.ol-control button:hover {
  background: $default-color-background-light;
  color: $default-color;
}
.ol-control button:focus {
  outline: none;
  background: #FFFFFF;
}

.ol-zoom .ol-zoom-in  {
  color: #555555;
}
.ol-zoom .ol-zoom-out {
  color: #555555;
}

#attribution {
  position: absolute;
  z-index: 2;
  bottom: -5px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-left: auto;
  margin-right: auto;
  background: rgba(255,255,255,0.80);
  font-size: 12px;
  font-weight: 600;
}
</style>
